import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Compact controls for a per-dish BYO quantity override (dish context only):
 * a small amber tag sits left of the Quantity label, and an icon-only reset
 * button sits left of the quantity input. Tooltips carry the full wording.
 */
export const OverrideTag: React.FC = () => {
    const { t } = useTranslation();
    return (
        <span title={t('costPrice.byo.customForDish')} className="inline-flex items-center shrink-0">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#F79009" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2H2v10l9.29 9.29a1 1 0 0 0 1.42 0l8.58-8.58a1 1 0 0 0 0-1.42L12 2z" />
                <circle cx="7" cy="7" r="0.5" fill="#F79009" />
            </svg>
        </span>
    );
};

export const OverrideResetButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    const { t } = useTranslation();
    return (
        <button
            type="button"
            onClick={onClick}
            title={t('costPrice.byo.resetToShared')}
            className="p-1 text-[#475467] dark:text-textSecondary-dark hover:text-[#2563EB] transition-colors"
        >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                <path d="M3 3v5h5" />
            </svg>
        </button>
    );
};
